/**
 * Custom error class for validation failures in chat input components.
 * This allows us to distinguish between validation errors (where we want to preserve user input)
 * and unexpected errors (which should be re-thrown).
 */
export class ChatInputValidationError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'ChatInputValidationError'
  }
}
